/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_PercentageInputs */

const en_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

const de_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozent`)
};

const es_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje`)
};

const fr_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage`)
};

const it_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentuale`)
};

const pt_br2_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentagem`)
};

const pl_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procent`)
};

const hu_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Százalék`)
};

const ro_admin_plan_discount_form_percentage = /** @type {(inputs: Admin_Plan_Discount_Form_PercentageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procent`)
};

/**
* | output |
* | --- |
* | "Percentage" |
*
* @param {Admin_Plan_Discount_Form_PercentageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_percentage = /** @type {((inputs?: Admin_Plan_Discount_Form_PercentageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_PercentageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_percentage(inputs)
	if (locale === "de") return de_admin_plan_discount_form_percentage(inputs)
	if (locale === "es") return es_admin_plan_discount_form_percentage(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_percentage(inputs)
	if (locale === "it") return it_admin_plan_discount_form_percentage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_percentage(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_percentage(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_percentage(inputs)
	return ro_admin_plan_discount_form_percentage(inputs)
});
export { admin_plan_discount_form_percentage as "admin.plan_discount_form.percentage" }